export const MASK_CPF = "999.999.999-99";
export const MASK_CNPJ = "99.999.999/9999-99";
export const MASK_CEP = "99999-999";
export const MASK_RG = "99999999-9";
export const MASK_DATE = "99/99/9999";
export const MASK_PHONE_NUMBER = "+55 (99) 9999-9999";
export const MASK_MOBILE_PHONE_NUMBER = "+99 (99) 9 9999-9999";

export const PATTERN_CEP = /\d{5}[-]\d{3}/;
export const PATTERN_CPF = /\d{3}[.]\d{3}[.]\d{3}[-]\d{2}/;
export const PATTERN_CNPJ = /\d{2}[.]\d{3}[.]\d{3}[/]\d{4}[-]\d{2}/;

export function asCNPJ(value: string) {
  if (!value) return "";
  return String(value).replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
}

export function asCPF(value: string) {
  if (!value) return "";
  return String(value).replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
}

export function asCEP(value: string) {
  if (!value) return "";
  return String(value).replace(/^(\d{5})(\d{3})/, "$1-$2");
}

export function asPhoneNumber(value: string) {
  if (!value) return "";
  value = String(value).replace(/\D/g, "");

  if (value.length <= 12) {
    return value.replace(/^(\d{2})(\d{2})(\d{4})(\d{4})$/, "+$1 ($2) $3-$4");
  }

  return value.replace(/^(\d{2})(\d{2})(\d{1})(\d{4})(\d{4})$/, "+$1 ($2) $3 $4-$5");
}

export function asCurrency(value: number | string, fractionDigits = 2) {
  if (value === null || value === undefined) return "";
  value = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(value)) return "";

  return value.toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  });
}

export function asPercentage(value: number | string) {
  if (value === null || value === undefined) return "";
  value = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(value)) return "";

  return `${value}%`;
}

export function pickPhoneNumberMask(phone: string) {
  if (!phone) return MASK_PHONE_NUMBER + "9";
  return String(phone).replace(/\D/g, "").length < 13
    ? MASK_PHONE_NUMBER + "9"
    : MASK_MOBILE_PHONE_NUMBER;
}
